import { render } from "./HeroCarousel.vue?vue&type=template&id=5012f8d9"
import script from "./HeroCarousel.vue?vue&type=script&lang=js"
export * from "./HeroCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__